import { ILocationDirtworkCost } from '../../interfaces/ilocation-dirtwork-cost';
import { UnitOfMeasure } from '../unit-of-measure';

export class LocationDirtworkCostBase {
  LocationDirtworkCostId: number;
  DrillingItemId: number;
  PadSize: number;
  UnitCost: number;
  UnitOfMeasureId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: ILocationDirtworkCost) {
    if (item) {

      this.LocationDirtworkCostId = item.LocationDirtworkCostId;
      this.DrillingItemId = item.DrillingItemId;
      this.PadSize = item.PadSize;
      this.UnitCost = item.UnitCost;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}